import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-data-found',
  templateUrl: './no-data-found.component.html',
  styleUrls: ['./no-data-found.component.scss'],
  // every other shared component sets this explicitly; without it Angular 21
  // treats the component as standalone, which is why it was never added to
  // SharedModule's declarations and <app-no-data-found> rendered nothing
  standalone: false
})
export class NoDataFoundComponent {
  // Using the ? operator means these properties are optional
  @Input() imageUrl?: string;
  @Input() heading?: string;
  @Input() subtext?: string;
}
